<template lang="pug">
  #owners
    el-row(type="flex" justify="end")
      el-button.create-button(type="primary" @click="openCreateDialog") {{ $t('Owners.create') }}
    .content
      OwnersTable.group(:owners="owners" :edit="false" :loading="isLoading" @openCreateDialog="openCreateDialog")

    el-dialog(:title="$t('Owners.create')" width="65%" top="8vh" :visible.sync="isShowingDialog" @closed="closedDialog")
      el-form.form(label-position="left" :rules="rules" label-width="250px" ref="dialogForm" :model="dialogForm" v-loading="isLoadingOwnerSetting")
        template(v-if="user.company.type === 'admin'")
          .split
            el-form-item(:label="$t('Owners.company.type')" prop="company.type")
              el-select.types(v-model="dialogForm.company.type" :placeholder="$t('Owners.select_placeholder', {select: $t('Owners.company.type') })")
                el-option(v-for="(type, index) in types" :key="index" :value="type" :label="$t('Owners.company.types.'+type)")
        .split
          el-form-item(:label="$t('Owners.company.name')" prop="company.name")
            el-input.name(v-model="dialogForm.company.name" :placeholder="$t('Owners.input_placeholder', {input: $t('Owners.company.name') })" maxlength="64" show-word-limit)
          el-form-item(:label="$t('Owners.company.kana')" prop="company.name_kana")
            el-input.kana(v-model="dialogForm.company.name_kana" :placeholder="$t('Owners.input_placeholder', {input: $t('Owners.company.kana') })" maxlength="128" show-word-limit)
          el-form-item(:label="$t('Owners.company.zip_code')" prop="company.zip_code")
            el-input.zip_code(v-model="dialogForm.company.zip_code" :placeholder="$t('Owners.input_placeholder', {input: $t('Owners.company.zip_code') })" maxlength="7" show-word-limit)
          el-form-item(:label="$t('Owners.company.address')" prop="company.address")
            el-input(v-model="dialogForm.company.address" :placeholder="$t('Owners.input_placeholder', {input: $t('Owners.company.address') })" maxlength="128" show-word-limit)
          el-form-item(:label="$t('Owners.company.phone_number')" prop="company.phone_number")
            el-input.tel(v-model="dialogForm.company.phone_number" :placeholder="$t('Owners.input_placeholder', {input: $t('Owners.company.phone_number') })" maxlength="16" show-word-limit)
          el-form-item(:label="$t('Owners.company.fax_number')" prop="company.fax_number")
            el-input.tel(v-model="dialogForm.company.fax_number" :placeholder="$t('Owners.input_placeholder', {input: $t('Owners.company.fax_number') })" maxlength="16" show-word-limit)
          el-form-item(:label="$t('Owners.company.invoice_email')" prop="company.invoice_email")
            el-input(v-model="dialogForm.company.invoice_email" :placeholder="$t('Owners.input_placeholder', {input: $t('Owners.company.invoice_email') })" maxlength="128" show-word-limit)
        .split
          el-form-item(:label="$t('Owners.owner.name')" prop="owner.name")
            el-input.name(v-model="dialogForm.owner.name" :placeholder="$t('Owners.input_placeholder', {input: $t('Owners.owner.name') })" maxlength="64" show-word-limit)
          el-form-item(:label="$t('Owners.owner.email')" prop="owner.email")
            el-input(v-model="dialogForm.owner.email" :placeholder="$t('Owners.input_placeholder', {input: $t('Owners.owner.email') })" maxlength="128" show-word-limit autocomplete="off")
          el-form-item(:label="$t('Owners.owner.password')" prop="owner.password")
            el-input.password(v-model="dialogForm.owner.password" :placeholder="$t('Owners.input_placeholder', {input: $t('Owners.owner.password') })" show-password autocomplete="off")
        .split
          el-form-item(:label="$t('Owners.company.timezone')" prop="company.timezone")
            el-select.timezones(v-model="dialogForm.company.timezone_tzinfo_ident" size="medium" :placeholder="$t('Owners.select_placeholder', {select: $t('Owners.company.timezone') })")
              el-option(v-for="tz in timezones" :key="tz.city" :value="tz.city" :label="'GMT' + tz.offset + ' ' + $t('MetaZones.'+tz.metazone) + ' (' + $t('TimezoneCities.'+tz.city) + ')'")
        el-form-item(:label="$t('Owners.company.note')")
          el-input(type="textarea" :rows="3" v-model="dialogForm.company.notes")
      span.dialog-footer(slot="footer")
        el-button(@click="isShowingDialog=false" :disabled="isLoadingOwnerSetting") {{ $t('Cuona.Group.cancel') }}
        el-button(type="primary" @click="createOwner" :disabled="isLoadingOwnerSetting" :loading="isCreateLoading") {{ $t('Cuona.Group.create') }}
</template>

<script>
import OwnersTable from './OwnersTable'
import API from '@/api/companies'
import v2API from '@/api/v2/users'
import ownerTypes from '@/utils/defines/owner'

export default {
  mixins: [ownerTypes],
  components: { OwnersTable },
  data () {
    const checkPassword = (rule, value, callback) => {
      var re = /^[A-Za-z0-9!"#$%&'()\*\+\-\.,\/:;<=>?@\[\\\]^_`{|}~]*$/
      if (re.test(value)) {
        callback();
      } else {
        callback(new Error(this.$t('Owners.input_password_error')));
      }
    };
    const checkZipcode = (rule, value, callback) => {
      var re = /^[0-9]*$/
      if (re.test(value)) {
        if (value.length === 7) {
          callback();
        } else {
          callback(new Error(this.$t('Owners.input_length7_error')));
        }
      } else {
        callback(new Error(this.$t('Owners.input_number_error')));
      }
    };
    return {
      isLoading: true,
      isCreateLoading: false,
      isShowingDialog: false,
      isLoadingOwnerSetting: false,
      owners: [],
      timezones: [],
      dialogForm: {
        company: {
          name: '',
          name_kana: '',
          type: 'normal',
          zip_code: null,
          address: '',
          phone_number: '',
          fax_number: '',
          timezone_tzinfo_ident: '',
          invoice_email: '',
          currency: 'JPY',
          notes: ''
        },
        owner: {
          name: '',
          email: '',
          password: ''
        }
      },
      rules: {
        company: {
          type: [
            { required: true, message: this.$t('Owners.select_blank_error'),trigger: 'change' }
          ],
          name: [
            { required: true, message: this.$t('Owners.input_blank_error'), trigger: 'blur' }
          ],
          zip_code: [
            { required: true, message: this.$t('Owners.input_blank_error'), trigger: 'blur' },
            { validator: checkZipcode, trigger: 'blur' }
          ],
          address: [
            { required: true, message: this.$t('Owners.input_blank_error'), trigger: 'blur' }
          ],
          timezone_tzinfo_ident: [
            { required: true, message: this.$t('Owners.select_blank_error'), trigger: 'change' }
          ],
          invoice_email: [
            { required: true, message: this.$t('Owners.input_blank_error'), trigger: 'blur' },
            { type: 'email', message: this.$t('Owners.input_email_error'), trigger: 'blur' }
          ]
        },
        owner: {
          name: [
            { required: true, message: this.$t('Owners.input_blank_error'), trigger: 'blur' }
          ],
          email: [
            { required: true, message: this.$t('Owners.input_blank_error'), trigger: 'blur' },
            { type: 'email', message: this.$t('Owners.input_email_error'), trigger: 'blur' }
          ],
          password: [
            { required: true, message: this.$t('Owners.input_blank_error'), trigger: 'blur' },
            { min: 8, max: 64, message: this.$t('Owners.input_password_length8_error'), trigger: 'blur' },
            { validator: checkPassword, trigger: 'blur' }
          ]
        }
      }
    }
  },
  title() {
    return this.$t('submenus.owners')
  },
  mounted() {
    this.loadTimezones();
    this.loadOwners();
  },
  computed: {
    user: function() {
      return this.$store.state.user.user
    }
  },
  methods: {
    // グループ作成ダイアログを開く
    openCreateDialog: function() {
      this.isShowingDialog = true;
    },

    // グループ作成ダイアログを閉じた後の処理
    closedDialog: function() {
      this.$refs['dialogForm'].resetFields();
      this.dialogForm.company.timezone_tzinfo_ident = ''
      // this.$refs.ownersTable.clearSelection()
    },

    // タイムゾーン（これ共通関数にした方が良いかも）
    loadTimezones() {
      const obj = this;
      API.getTimezones().then(function (response) {
        if (response && response.timezones) {
          obj.timezones = response.timezones.sort((a,b) => {
            const offsetA = parseInt(a.offset.replace(':',''));
            const offsetB = parseInt(b.offset.replace(':',''));
            if (offsetA !== offsetB) { return offsetA - offsetB }
            const stringA = (obj.$t('MetaZones.'+a.metazone)+obj.$t('TimezoneCities.'+a.city));
            const stringB = (obj.$t('MetaZones.'+b.metazone)+obj.$t('TimezoneCities.'+b.city));
            if (stringA < stringB) { return -1 }
            if (stringA > stringB) { return 1 }
            return 0;
          });
        } else {
          obj.timezones = [];
        }
        if (response && response.current_timezone) {
          obj.currentTimezone = response.current_timezone;
        }
      });
    },
    //オーナー一覧取得
    loadOwners: function() {
      const _this = this
      v2API.getCompanies(this.$store.state.user.user.company.type)
      .then(function (response) {
        _this.owners = response.companies
        _this.isLoading = false
      })
    },

    // オーナー作成
    createOwner: function() {
      const that = this;
      this.$refs['dialogForm'].validate((valid) => {
        if (valid) {
          that.isCreateLoading = true
          API.createCompany(this.dialogForm).then(function (response) {
            if (response.success){
              that.$message({
                showClose: true,
                message: that.$t('Owners.success'),
                type: 'success'
              });
              that.isCreateLoading = false
              that.isShowingDialog = false
            } else {
              that.$message({
                showClose: true,
                message: "["+response.meta.code+"]" + that.$t('Owners.create_error'),
                type: 'error'
              });
            }
          }).catch((error) => {
            let errorMessage = 'Owners.create_error';
            switch(error.status) {
              case 401:
                errorMessage = 'Owners.error401';
                break;
            }
            if (error.data.meta.type === "duplicate_user_email") {
              errorMessage = 'Owners.error400Already';
            }
            that.$message({
              showClose: true,
              message: "["+error.code+"]" + that.$t(errorMessage),
              type: 'error'
            });
          }).finally(() => {
            that.isLoadingOwnerSetting = false;
          });
        } else {
          that.$message({
            showClose: true,
            message: that.$t('Owners.create_error'),
            type: 'error'
          });
          return false;
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables.scss";
@import "../../styles/table-layout.scss";

.create-button {
  margin: 20px 40px -20px;
}

.name {
  width: 350px;
}

.zip_code, .password, .types, .tel {
  width: 250px;
}

.timezones {
  width: 500px;
}

.split {
  border-bottom: 1px solid $border;
  margin-bottom: 20px;
}

.el-dialog {
  .content {
    margin: 0;
  }

  .device-image {
    position: relative;
    top:4px;
    width: 20px;
    margin-right: 8px;
  }

  th {
    font-weight: normal;
    font-size: 12px;
    padding: 0 20px;
    color: #999;
  }

  .el-table-row {
    height: 40px;
  }
}

</style>
